export enum EmployeePreferenceEnum {
    Oriented = 1,
    Favourite = 2,
    DoNotSend = 3
}
